import { addAnswersData, addEvaluationData, addQuestionData, addTemplateData, completeEvaluationByIds, deleteQuestionData, deleteTemplateData, getAllevaluationsList, getAllGiveFeedbackData, getAnswersByEvaluationByIds, getFilteredEvaluations, getQuestionsListData, getReviewsList, getTemplatesListData } from "../api/feedbackApi";
import { failure, request, success, FEEDBACK_REQUEST } from "./utilities";


export function getTemplatesList(token) {
    return (dispatch) => {
        dispatch(request(FEEDBACK_REQUEST.GET_TEMPLATES_LISTING_REQUEST));
        getTemplatesListData(token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(FEEDBACK_REQUEST.GET_TEMPLATES_LISTING_SUCCESS, response.data.data))
                }
                else {
                    dispatch(failure(FEEDBACK_REQUEST.GET_TEMPLATES_LISTING_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(FEEDBACK_REQUEST.GET_TEMPLATES_LISTING_FAILURE, (error && error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message)))
            }
        )
    };
}

export function getQuestionsList(formTypeId, token) {
    return (dispatch) => {
        dispatch(request(FEEDBACK_REQUEST.GET_QUESTION_LISTING_REQUEST));
        getQuestionsListData(formTypeId, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(FEEDBACK_REQUEST.GET_QUESTION_LISTING_SUCCESS, response.data.data))
                }
                else {
                    dispatch(failure(FEEDBACK_REQUEST.GET_QUESTION_LISTING_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(FEEDBACK_REQUEST.GET_QUESTION_LISTING_FAILURE, (error && error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message)))
            }
        )
    };
}

export function getFeedbackReviewsList(token) {
    return (dispatch) => {
        dispatch(request(FEEDBACK_REQUEST.GET_FEEDBACK_REVIEWS_LISTING_REQUEST));
        getReviewsList(token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(FEEDBACK_REQUEST.GET_FEEDBACK_REVIEWS_LISTING_SUCCESS, response.data.data))
                }
                else {
                    dispatch(failure(FEEDBACK_REQUEST.GET_FEEDBACK_REVIEWS_LISTING_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(FEEDBACK_REQUEST.GET_FEEDBACK_REVIEWS_LISTING_FAILURE, (error && error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message)))
            }
        )
    };
}

export function getAllEvaluationList(token) {
    return (dispatch) => {
        dispatch(request(FEEDBACK_REQUEST.GET_EVALUATION_LISTING_REQUEST));
        getAllevaluationsList(token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(FEEDBACK_REQUEST.GET_EVALUATION_LISTING_SUCCESS, response.data.data))
                }
                else {
                    dispatch(failure(FEEDBACK_REQUEST.GET_EVALUATION_LISTING_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(FEEDBACK_REQUEST.GET_EVALUATION_LISTING_FAILURE, (error && error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message)))
            }
        )
    };
}

export function getAllGiveFeedback(userId, token) {
    return (dispatch) => {
        dispatch(request(FEEDBACK_REQUEST.GET_GIVE_FEEDBACK_REQUEST));
        getAllGiveFeedbackData(userId, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(FEEDBACK_REQUEST.GET_GIVE_FEEDBACK_SUCCESS, response.data.data))
                }
                else {
                    dispatch(failure(FEEDBACK_REQUEST.GET_GIVE_FEEDBACK_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(FEEDBACK_REQUEST.GET_GIVE_FEEDBACK_FAILURE, (error && error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message)))
            }
        )
    };
}

export function addEvaluation(evaluationData, token, moveToNext) {
    return (dispatch) => {
        dispatch(request(FEEDBACK_REQUEST.ADD_EVALUATION_REQUEST));
        addEvaluationData(evaluationData, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(FEEDBACK_REQUEST.ADD_EVALUATION_SUCCESS, response.data.data))
                    dispatch(getAllEvaluationList(token))
                    if (moveToNext) {
                        moveToNext();
                    }
                }
                else {
                    dispatch(failure(FEEDBACK_REQUEST.ADD_EVALUATION_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(FEEDBACK_REQUEST.ADD_EVALUATION_FAILURE, (error && error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message)))
            }
        )
    };
}

export function addTemplate(templateData, token, moveToNext) {
    return (dispatch) => {
        dispatch(request(FEEDBACK_REQUEST.ADD_TEMPLATE_REQUEST));
        addTemplateData(templateData, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(FEEDBACK_REQUEST.ADD_TEMPLATE_SUCCESS, response.data.data))
                    dispatch(getTemplatesList(token));
                    if (moveToNext) {
                        moveToNext();
                    }
                }
                else {
                    dispatch(failure(FEEDBACK_REQUEST.ADD_TEMPLATE_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(FEEDBACK_REQUEST.ADD_TEMPLATE_FAILURE, (error && error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message)))
            }
        )
    };
}

export function addQuestion(questionData, token, moveToNext) {
    return (dispatch) => {
        dispatch(request(FEEDBACK_REQUEST.ADD_QUESTION_REQUEST));
        addQuestionData(questionData, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(FEEDBACK_REQUEST.ADD_QUESTION_SUCCESS, response.data.data))
                    dispatch(getTemplatesList(token))
                    if (moveToNext) {
                        moveToNext();
                    }
                }
                else {
                    dispatch(failure(FEEDBACK_REQUEST.ADD_QUESTION_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(FEEDBACK_REQUEST.ADD_QUESTION_FAILURE, (error && error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message)))
            }
        )
    };
}

export function addAnswers(answersData, token, successCall) {
    return (dispatch) => {
        dispatch(request(FEEDBACK_REQUEST.ADD_ANSWERS_REQUEST));
        addAnswersData(answersData, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(FEEDBACK_REQUEST.ADD_ANSWERS_SUCCESS, response.data.data))
                    if (successCall) {
                        successCall(response.data.data[0].isCompleted);
                    }
                }
                else {
                    dispatch(failure(FEEDBACK_REQUEST.ADD_ANSWERS_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(FEEDBACK_REQUEST.ADD_ANSWERS_FAILURE, (error && error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message)))
            }
        )
    };
}

export function deleteQuestion(QuestionId, token, moveToNext) {
    return (dispatch) => {
        dispatch(request(FEEDBACK_REQUEST.DELETE_QUESTION_REQUEST));
        deleteQuestionData(QuestionId, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(FEEDBACK_REQUEST.DELETE_QUESTION_SUCCESS, QuestionId))
                    dispatch(getTemplatesList(token))
                    if (moveToNext) {
                        moveToNext();
                    }
                }
                else {
                    dispatch(failure(FEEDBACK_REQUEST.DELETE_QUESTION_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(FEEDBACK_REQUEST.DELETE_QUESTION_FAILURE, (error && error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message)))
            }
        )
    };
}

export function deleteTemplate(templateId, token, moveToNext) {
    return (dispatch) => {
        dispatch(request(FEEDBACK_REQUEST.DELETE_TEMPLATE_REQUEST));
        deleteTemplateData(templateId, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(FEEDBACK_REQUEST.DELETE_TEMPLATE_SUCCESS, templateId))
                    if (moveToNext) {
                        moveToNext();
                    }
                }
                else {
                    dispatch(failure(FEEDBACK_REQUEST.DELETE_TEMPLATE_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(FEEDBACK_REQUEST.DELETE_TEMPLATE_FAILURE, (error && error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message)))
            }
        )
    };
}

export function getAnswersByEvaluation(evaluationId, formTypeId, token) {
    return (dispatch) => {
        dispatch(request(FEEDBACK_REQUEST.GET_ANSWERS_BYEVALUATION_ID_REQUEST));
        getAnswersByEvaluationByIds(evaluationId, formTypeId, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(FEEDBACK_REQUEST.GET_ANSWERS_BYEVALUATION_ID_SUCCESS, response.data.data))
                }
                else {
                    dispatch(failure(FEEDBACK_REQUEST.GET_ANSWERS_BYEVALUATION_ID_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(FEEDBACK_REQUEST.GET_ANSWERS_BYEVALUATION_ID_FAILURE, (error && error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message)))
            }
        )
    };
}

export function completeEvaluation(completeData, token, userId, moveToNext) {
    return (dispatch) => {
        dispatch(request(FEEDBACK_REQUEST.COMPLETE_EVALUATION_REQUEST));
        completeEvaluationByIds(completeData, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(FEEDBACK_REQUEST.COMPLETE_EVALUATION_SUCCESS, response.data.data))
                    dispatch(getAllGiveFeedback(userId, token))
                    if (moveToNext) {
                        moveToNext();
                    }
                }
                else {
                    dispatch(failure(FEEDBACK_REQUEST.COMPLETE_EVALUATION_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(FEEDBACK_REQUEST.COMPLETE_EVALUATION_FAILURE, (error && error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message)))
            }
        )
    };
}

export function getFilteredEvaluation(name, date, status, token) {
    return (dispatch) => {
        dispatch(request(FEEDBACK_REQUEST.GET_EVALUATION_LISTING_REQUEST));
        getFilteredEvaluations(name, date, status, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(FEEDBACK_REQUEST.GET_EVALUATION_LISTING_SUCCESS, response.data.data))
                }
                else {
                    dispatch(failure(FEEDBACK_REQUEST.GET_EVALUATION_LISTING_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(FEEDBACK_REQUEST.GET_EVALUATION_LISTING_FAILURE, (error && error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message)))
            }
        )
    };
}